(function() {
  function variantIdFromHref(href) {
    if (!href) return null;
    var match = href.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  function processingText(button) {
    return button.dataset.processingText || 'Processing...';
  }

  function buyNowLabel(button) {
    return button.dataset.buyNowLabel || 'Buy Now';
  }

  function soldOutText(button) {
    return button.dataset.soldOutText || 'Sold out';
  }

  function setBuyNowAvailable(button) {
    button.disabled = false;
    if (!button.hasAttribute('aria-busy')) {
      button.textContent = buyNowLabel(button);
    }
  }

  function setBuyNowSoldOut(button) {
    button.disabled = true;
    button.removeAttribute('aria-busy');
    button.textContent = soldOutText(button);
  }

  function cardTitleFromSwatch(card, swatch) {
    var baseTitle = card.dataset.ssBaseTitle || '';
    if (!baseTitle) return '';

    var colorName = swatch.dataset.colorName || '';
    if (!colorName) {
      var hidden = swatch.querySelector('.visually-hidden');
      colorName = hidden ? hidden.textContent.trim() : '';
    }

    return colorName ? baseTitle + '-' + colorName : baseTitle;
  }

  function updateCardTitle(card, swatch) {
    var titleLink = card.querySelector('[data-ss-card-title]');
    if (!titleLink) return;

    var displayTitle = cardTitleFromSwatch(card, swatch);
    titleLink.textContent = displayTitle;

    var mediaLink = card.querySelector('.ss-b2g1-card__media-link');
    if (mediaLink) {
      mediaLink.setAttribute('title', displayTitle);
      mediaLink.setAttribute('aria-label', displayTitle);
    }
  }

  function syncSwatchSelection(swatch) {
    var card = swatch.closest('[data-ss-b2g1-card]');
    if (!card) return;

    var href = swatch.getAttribute('data-href');
    if (href) {
      card.querySelectorAll('a.ss-b2g1-card__btn--outline, .ss-b2g1-card__title a, .ss-b2g1-card__media-link').forEach(function(link) {
        link.setAttribute('href', href);
      });
    }

    updateCardTitle(card, swatch);

    var buyNowBtn = card.querySelector('[data-ss-buy-now]');
    if (!buyNowBtn || buyNowBtn.hasAttribute('aria-busy')) return;

    var variantId = variantIdFromHref(swatch.dataset.href);
    if (variantId) {
      buyNowBtn.dataset.variantId = variantId;
    }

    if (swatch.dataset.available === 'false') {
      setBuyNowSoldOut(buyNowBtn);
    } else {
      setBuyNowAvailable(buyNowBtn);
    }
  }

  function initB2g1Cards(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ss-b2g1-card]').forEach(function(card) {
      var activeSwatch = card.querySelector('.product-card-swatch.active') || card.querySelector('.product-card-swatch');
      if (activeSwatch) {
        syncSwatchSelection(activeSwatch);
      }
    });
  }

  function addItemsAndCheckout(items, button, label) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = processingText(button);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) {
            throw new Error(data.description || 'Failed to add to cart');
          });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        window.alert(error.message || 'Unable to process your request.');
      });
  }

  function bundleSelectedItems(root) {
    return Array.prototype.slice
      .call(root.querySelectorAll('[data-ss-bundle-item]'))
      .filter(function(item) {
        var checkbox = item.querySelector('[data-ss-bundle-checkbox]');
        return checkbox && checkbox.checked && !checkbox.disabled;
      });
  }

  document.addEventListener('mouseover', function(event) {
    var swatch = event.target.closest('.ss-b2g1-card .product-card-swatch');
    if (swatch) {
      syncSwatchSelection(swatch);
    }
  });

  document.addEventListener('click', function(event) {
    var swatch = event.target.closest('.ss-b2g1-card .product-card-swatch');
    if (swatch) {
      syncSwatchSelection(swatch);
      return;
    }

    var bundleButton = event.target.closest('[data-ss-bundle-buy-now]');
    if (bundleButton && !bundleButton.disabled) {
      event.preventDefault();

      var bundleRoot = bundleButton.closest('.ss-bundle');
      if (!bundleRoot) return;

      var selected = bundleSelectedItems(bundleRoot);
      if (!selected.length) return;

      var bundleLabel = buyNowLabel(bundleButton);
      var payload = selected.map(function(item) {
        return { id: Number(item.dataset.variantId), quantity: 1 };
      });

      addItemsAndCheckout(payload, bundleButton, bundleLabel);
      return;
    }

    var button = event.target.closest('[data-ss-buy-now]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var label = buyNowLabel(button);
    addItemsAndCheckout([{ id: Number(variantId), quantity: 1 }], button, label);
  });

  function boot() {
    initB2g1Cards(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) {
      initB2g1Cards(section);
    }
  });
})();
